export const DEFAULT_LIBRARY_ELEMENTS_LIMIT = 12
